import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/CheckList/selectRow',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async save(params)
    {
        try
        {
            let response;
            if (typeof params.id !== 'undefined' && params.id != '')
            {
                response = await axios.post('/CheckList/updateRow', params);
            }
            else
            {
                response = await axios.post('/CheckList/insertRow', params);
            }
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/CheckList/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
